




















import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListShiiresaki',
  components: {
    CtrlSearchCommonComponents,
  },
  props: {
    targetYmd: {
      type: Number,
      required: true,
    },
    shiiresakiKb: {
      type: Number,
    },
    shiharaisakiKb: {
      type: Number,
    },
    soshikiCd: {
      type: Number,
    },
    gyoshuCd: {
      type: Number,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'shiiresakiCd',
        width: 80,
      },
      {
        text: '名称',
        sortable: true,
        value: 'shiiresakiRyakuMei',
        width: 340,
      },
      {
        text: '支払先コード',
        sortable: true,
        value: 'shiharaisakiCd',
        width: 130,
      },
      {
        text: '支払先名',
        sortable: true,
        value: 'shiharaisakiMei',
        width: 340,
      },
    ],
    formatColName: 'shiiresakiCd',
  }),
});
